import { IpsTableDesktop } from "./components/IpsTableDesktop";
import { IpsTableMobile } from "./components/IpsTableMobile";

import { DesctopWrapper, MobileWrapper, Wrapper } from "./IpTable.styled";

export const IpsTable = ({ ips, webRtcStatus, userIp }) => {
  return (
    <Wrapper>
      <DesctopWrapper>
        <IpsTableDesktop
          ips={ips}
          webRtcStatus={webRtcStatus}
          userIp={userIp}
        />
      </DesctopWrapper>

      <MobileWrapper>
        <IpsTableMobile ips={ips} webRtcStatus={webRtcStatus} userIp={userIp} />
      </MobileWrapper>
    </Wrapper>
  );
};
